var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_11825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8003 28.3242V11.4492C12.8003 11.0992 12.9128 10.8242 13.1378 10.6242C13.3628 10.4242 13.6253 10.3242 13.9253 10.3242C14.0253 10.3242 14.1253 10.3367 14.2253 10.3617C14.3253 10.3867 14.4253 10.4242 14.5253 10.4742L27.8003 18.9492C27.9753 19.0742 28.1065 19.2117 28.194 19.3617C28.2815 19.5117 28.3253 19.6867 28.3253 19.8867C28.3253 20.0867 28.2815 20.2617 28.194 20.4117C28.1065 20.5617 27.9753 20.6992 27.8003 20.8242L14.5253 29.2992C14.4253 29.3492 14.3253 29.3867 14.2253 29.4117C14.1253 29.4367 14.0253 29.4492 13.9253 29.4492C13.6253 29.4492 13.3628 29.3492 13.1378 29.1492C12.9128 28.9492 12.8003 28.6742 12.8003 28.3242Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_11825",
    x: 8.00029,
    y: 5.52422,
    width: 25.1249,
    height: 28.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11825",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySelected);
export default __webpack_public_path__ + "static/media/play-selected.eb1178c1ed2b4af46fea8ca57d8bf6c1.svg";
export { ForwardRef as ReactComponent };